const API_BASEURL = process.env.REACT_APP_API_BASEURL;
const API_BASEURLLOCAL = process.env.REACT_APP_API_BASEURL_LOCAL;
const DOMAIN_NAME = process.env.REACT_APP_DOMAIN_NAME;
const VERSION = process.env.REACT_APP_VERSION;
const APPID = process.env.REACT_APP_APP_ID;
const REFERER = process.env.REACT_APP_REFERER;
const API_BASEURLICON = process.env.REACT_APP_API_BASEURLICON;

export { API_BASEURL, DOMAIN_NAME, API_BASEURLLOCAL, VERSION, APPID, REFERER,API_BASEURLICON };
